import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import centerImage from "../../assets/infosys.svg";
import userImage from "../../assets/user.png";

import Webcam from "react-webcam"; // Import react-webcam
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { User } from "react-feather"; // Import the User icon
import QRCode from "qrcode";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import {
  fetchVisitorTypes,
  fetchMeetingVenues,
  insertAppointment,
  fetchGateDetails,
  fetchNationality,
  fetchBuildingsByGate,
  fetchIdProofTypes,
} from "../../services/Api";
import { FaceDetection } from "@mediapipe/face_detection";
import { FiEdit } from "react-icons/fi"; // Using react-icons library

const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px; /* Adjusted margin-bottom for spacing */
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: "Segoe UI", "Semibold";
  color: #2b3497;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ButtonGroupLeft = styled.div`
  display: flex;
  gap: 10px; /* Space between buttons */
`;

const ButtonGroupRight = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* Space between buttons */
  width: 100%;
`;

const Button = styled.button`
  background-color: #2b3497;
  color: #fff;
  box-shadow: 0px 5px 10px #2b349754;
  border-radius: 12px;
  opacity: 1;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #1e2a6d;
  }
  &:active {
    background-color: #162055;
  }
`;
const ScrollableTableContainer = styled.div`
  margin-top: 15px;
  max-height: 500px; /* Set the desired height */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden; /* Disable horizontal scrolling */
  border: 1px solid #ddd; /* Optional: Add a border for better visibility */
`;
const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(
    to bottom,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 6px;
  opacity: 1;
`;

const TableHeader = styled.thead`
  background: linear-gradient(
    to bottom,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  color: #000;
`;

const TableRow = styled.tr``;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
`;

const PopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  position: relative;
  background: linear-gradient(#ffffff, #f5f5f5, #ffffff);
  box-shadow: 0px 0px 1px #0000004a;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  width: 500px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const PopupButton = styled.button`
  background-color: #2b3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2b349754;
  cursor: pointer;
  margin-left: 10px;

  &.no-button {
    background-color: red; /* Change color to red for Close button */
  }
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2b3497;
  margin-bottom: 20px;
`;
const Circle = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 14px 44px;
`;

const ProfileIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;
const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 2px; /* Adjust gap between buttons */
  margin-bottom: 0px; /* Optional: Adjust margin bottom */
`;
const PhotoButton = styled.button`
  width: 79px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 9px;
`;

const ActionButton = styled.button`
  width: 79x;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
  @media (max-width: 1420px) and (min-width: 1220px) {
    width: 125px;
  }
  @media (max-width: 1220px) and (min-width: 1020px) {
    width: 100px;
  }
`;
const DisabledRow = styled(TableRow)`
  background-color: #f5f5f5;
  opacity: 0.6;
  pointer-events: none;
`;

const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const LabelValueContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 16px;
  color: #000;
  width: 40%; /* Control label width */
  text-align: left; /* Ensure label is aligned to the left */
  //   &::after {
  //     content: '*';
  //     color: red;
  //     margin-left: 5px;
  //   }
`;
const Asterisk = styled.span`
  color: red;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;

// Dropdown styles
const DropdownContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DropdownLabel = styled.label`
  font-weight: 400;
  font-size: 16px;
  color: #000;
  width: 40%; /* Same as Label width */
  text-align: left;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  width: 48%; /* Same as Value width */
  text-align: left;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;
const Input = styled.input`
  width:160px;
  border: none;
  border-bottom: 2px solid #3d46b4;
  background: transparent;
  padding: 10px;
  font-size: 16px;
  outline: none;
  flex: 1;
    margin-right: 20px; // Space to the right of the dropdown
    /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }

`;
const Dropdown = styled.select`
  width: 175px;
  border: none;
  border-bottom: 2px solid #3d46b4;
  font-size: 15px !important;
  padding: 10px;
  background: transparent;
  font-family: "Segoe UI", Regular;
  outline: none; /* Remove default focus outline */
  margin-right: 24px; // Space to the right of the dropdown
  flex: 1; // Makes the dropdown take up more space
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const GroupMemberDetailsUploadPage = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation();
  const { formData } = location.state || {};
  const { memberDetails } = location.state || {}; // Get memberDetails from location.state
  const { checkType } = location.state || {};

  const { formDataAdditional } = location.state || {};
  const { isCheckedB } = location.state || {};
  const { isCheckedP } = location.state || {};
  const { GroupType } = location.state || {};
  const { AppId } = location.state || {};

  console.log("memberDetails from GroupMemberDetailsUploadPage", memberDetails);
  console.log("GroupType", GroupType);

  console.log("formData", formData);

  console.log("isCheckedB", isCheckedB);
  console.log("isCheckedP", isCheckedP);

  const fileInputRef = useRef(null);
  const [tableData, setTableData] = useState(memberDetails || []); // Initialize tableData with memberDetails
  const [file, setFile] = useState(null); // Store the chosen file
  const [fileUploaded, setFileUploaded] = useState(false); // Track if the file has been uploaded
  const [getCheck, setGetCheck] = useState(); // Initialize tableData with memberDetails
  const [checkinMembers, setCheckinMembers] = useState([]);
  const [idProofTypes, setIdProofTypes] = useState([]);
  const normalizeValue = (val) => (val || "").toString().trim().toLowerCase();

  const getMemberSignature = (row) => {
    const firstName = normalizeValue(row["firstName"]);
    const lastName = normalizeValue(row["lastName"]);
    const email = normalizeValue(row["groupMemberEmail"]);
    return `${firstName}|${lastName}|${email}`;
};

  const handleChooseFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const chosenFile = event.target.files[0];
    if (chosenFile) {
      setFile(chosenFile); // Save the chosen file
      setFileUploaded(false);
      toast.success(
        "File chosen successfully, please click the upload button to update the table data.!",
      ); // Reset file upload status
      // Reset file upload status
    }
  };

  useEffect(() => {
  const getIdProofTypes = async () => {
    try {
      const types = await fetchIdProofTypes();
      setIdProofTypes(types || []);
    } catch (error) {
      console.error("Error fetching id proof types:", error);
    }
  };
  getIdProofTypes();
}, []);

  const handleUploadFileClick = () => {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    const binaryStr = e.target.result;
    const workbook = XLSX.read(binaryStr, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const excelData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

    const invalidIdProofRowIndices = [];
    const skippedDuplicateRowIndices = [];

    // Signatures of members already in the table (initial check-in members or a prior upload)
    const existingSignatures = new Set(
      tableData
        .map((row) => getMemberSignature(row))
        .filter((sig) => sig !== "||")
    );
    const seenInFile = new Set();

    const formattedData = excelData.map((row, index) => {
      const idProofValue = (row["ID Proof(eg:Passport)"] || "").toString().trim();
      const matchedIdProof = idProofTypes.find(
        (type) => (type.idProofDescription || "").toLowerCase() === idProofValue.toLowerCase()
      );

      if (idProofValue && !matchedIdProof) {
        invalidIdProofRowIndices.push(index + 2); // +2 to account for Excel header row
      }

      const formattedRow = {
        firstName: row["firstName"] || "",
        middleName: row["middleName"] || "",
        lastName: row["lastName"] || "",
        groupMemberEmail: row["email"] || "",
        company: row["company"] || "",
        gender: row["gender"] || "",
        nationality: row["nationality"] || "",
        nationalityCode: row["nationalityCode"] || "",
        visitorMobile: row["Mobile Number(eg:1234567890)"] || "",
        idProofName: matchedIdProof?.idProofDescription || idProofValue,
        idProofType: matchedIdProof ? matchedIdProof.id : null,
        idProofNo: row["ID Number(eg:123322442442)"] || "",
        photo: null, // Placeholder for photo
      };

      // Duplicate detection (skip duplicates instead of blocking the whole upload)
      const signature = getMemberSignature(formattedRow);
      let isDuplicate = false;
      if (signature !== "||") {
        if (seenInFile.has(signature) || existingSignatures.has(signature)) {
          isDuplicate = true;
          skippedDuplicateRowIndices.push(index + 2);
        } else {
          seenInFile.add(signature);
        }
      }

      return { ...formattedRow, __isDuplicate: isDuplicate };
    });

    if (invalidIdProofRowIndices.length > 0) {
      toast.error(
        `Rows ${invalidIdProofRowIndices.join(", ")} have an ID Proof value that doesn't match any valid ID Proof type. Please use the dropdown values from the Sample Template.`
      );
      return;
    }

    const uniqueRows = formattedData
      .filter((row) => !row.__isDuplicate)
      .map(({ __isDuplicate, ...rest }) => rest);

    if (skippedDuplicateRowIndices.length > 0) {
      toast.error(
        `Rows ${skippedDuplicateRowIndices.join(", ")} are duplicates (matching First Name, Last Name and Email) and were skipped.`
      );
    }

    setTableData((prevData) => [...prevData, ...uniqueRows]);
    toast.success("Data updated successfully");
  };

  reader.readAsBinaryString(file);
  setFile(null);
};

  const readExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      setTableData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleSampleTemplateClick = async () => {
    let genderList = ["Male", "Female", "Other"];

    let nationalityList = [];
    let nationalityCodeMap = {}; 
    try {
        const nation = await fetchNationality();
        nationalityList = (nation || []).map((n) => n.name).filter(Boolean);
        (nation || []).forEach((n) => {
            if (n?.name) nationalityCodeMap[n.name] = n.nationalityCode || "";
        });
    } catch (error) {
        console.error("Error fetching nationality for template:", error);
    }

    if (genderList.length === 0) genderList = ["Male", "Female", "Other"];
    if (nationalityList.length === 0) nationalityList = ["N/A"];

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("SampleTemplate");
    const listSheet = workbook.addWorksheet("Lists"); 

    const headers = [
        "firstName",
        "middleName",
        "lastName",
        "email",
        "gender",
        "nationality",
        "nationalityCode",
        "Mobile Number(eg:1234567890)",
        "ID Proof(eg:Passport)",
        "ID Number(eg:123322442442)"
    ];
    sheet.addRow(headers);
    sheet.addRow([]); 

    genderList.forEach((val, i) => { listSheet.getCell(i + 1, 1).value = val; });       
    nationalityList.forEach((val, i) => { listSheet.getCell(i + 1, 2).value = val; }); 

    listSheet.state = "hidden"; 

    const maxRows = 200; // apply dropdown validation to first 200 data rows

    // gender -> column E, nationality -> column F
    sheet.dataValidations.add(`E2:E${maxRows + 1}`, {
        type: "list",
        allowBlank: true,
        formulae: [`Lists!$A$1:$A$${genderList.length}`],
        showErrorMessage: true,
        errorTitle: "Invalid Gender",
        error: "Please select a value from the dropdown list."
    });

    sheet.dataValidations.add(`F2:F${maxRows + 1}`, {
        type: "list",
        allowBlank: true,
        formulae: [`Lists!$B$1:$B$${nationalityList.length}`],
        showErrorMessage: true,
        errorTitle: "Invalid Nationality",
        error: "Please select a value from the dropdown list."
    });

    // Basic column widths for readability
    sheet.columns = headers.map(() => ({ width: 22 }));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "SampleTemplate.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

  useEffect(() => {
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        const nationality = nation.find(
          (n) => n.name.toUpperCase() === formData.nationality.toUpperCase(),
        );

        if (nationality) {
          console.log("Nationality Code:", nationality.nationalityCode);
          setleaderCode(nationality.nationalityCode);
          return nationality.nationalityCode;
        } else {
          console.log("Nationality not found");
          return null;
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getNationality();

    // ✅ Safe cleanup function
    return () => {
      console.log("Cleanup executed");
      // Nothing to clean yet, but prevents error if something added later
    };
  }, []);
  const [profileImage, setProfileImage] = useState(null);
  const [leaderCode, setleaderCode] = useState(null);

  const handleSubmitClick = async () => {
    console.log("formData", formData);
    console.log("formData", formData);
    console.log("memberDetails", memberDetails);
    console.log("tableData", tableData);

    console.log("checkType", checkType);

    const getData = async () => {
      try {
        const getLocation = await axios.get(
          `/Location/Location/${formData.meetingVenue}`,
        );
        console.log("getLocation", getLocation);
        const empID = localStorage.getItem("employeeId");
        const currentUTCDate = new Date(
          Date.UTC(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes(),
            new Date().getUTCSeconds(),
          ),
        );
        const appointmentUpdateData = {
          AppointmentStatus: "Checked-In",
          ModifiedBy: empID,
          Id: AppId,
          ModifiedDate: currentUTCDate,
          VisitorMobile: formData.visitorMobile,
        };
        const STAT = "IN";

        const UpdateAppointment = await axios.post(
          `/GroupAppointment/AppointStatusUpd/${AppId},${STAT}`,
        );
        console.log("UpdateAppointment", UpdateAppointment);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    };
    if (formData.meetingVenue) {
      getData();
    }
    console.log("Table Data:", selectedRows);
    const empID = localStorage.getItem("employeeId");
    const getManagerDetails = await axios.get(`/Employee/${empID}`);
    console.log("getManagerDetails", getManagerDetails);
    const getLocation = await axios.get(
      `/Location/Location/${formData.meetingVenue || 0}`,
    );
    console.log("getLocation", getLocation);
    const addformData = formDataAdditional;
    const gateString = "Gate 1";
    const buildingName = encodeURIComponent(formData.building);
    const gateName = encodeURIComponent(formData.gate);

    const getBuildingID = await axios.get(
      `/Location/GetBuidingById?id=${buildingName}`,
    );
    console.log("getBuildingID", getBuildingID.data);
    let getGateID;

    if (!isNaN(gateName)) {
      // If gateName is a number → treat it as ID
      getGateID = await axios.get(`/Location/GetGateByID?id=${gateName}`);
    } else {
      // Else treat it as gate name
      getGateID = await axios.get(
        `/Location/GetGateByName?GateName=${gateName}`,
      );
    }

    console.log("Gate response:", getGateID.data);

    console.log("getGateID", getGateID.data);

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const checkInDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    // const getPhotoFromProfileImage = (photo) => {
    //   return photo ? photo.split(',')[1] : '';
    // };
    const getPhotoFromProfileImage = (profileImage) => {
      return profileImage ? profileImage.split(",")[1] : "";
    };

    const getGroupMemberId = (rowMemberId) => {
      if(rowMemberId === undefined) return null; // Handle case where rowMemberId is undefined
      const member = memberDetails.find(member => member?.id === rowMemberId);
      return member ? member?.id : null;
    };

    if (addformData.repeatVisit == 1) {
      const selectedRowData = selectedRows.map(
        (rowIndex) => tableData[rowIndex],
      ); // Get actual row data
      const requestData = [
        ...(GroupType
          ? [
              {
                checkInId: 0,
                hostName: String(getManagerDetails.data.id),
                hostMobile: getManagerDetails.data.employeeMobile,
                hostEmail: getManagerDetails.data.employeeMailId,
                checkInDateTime: checkInDateTime,
                visitorName: formData.firstName,
                visitorMobile: formData.visitorMobile,
                visitorCompany: formData.company,
                purpose: formData.purpose,
                vehicleno: formData.vehicleno,
                selectedVisitorTypeId: formData.selectedVisitorTypeId,
                locationId: getLocation.data.id,
                departmentId: 0,
                remarks: formData.remarks,
                idProofId: parseInt(formData.selectedIdProofTypeId) || 0,
                visitorIdNumber: formData?.idProofNo,
                visitorAssets: formData.assets,
                visitorPhoto: formData.visitorPhoto,
                gate: getGateID.data.id,
                building: getBuildingID.data.id,
                visitorSignature: "",
                duration: "",
                passReturned: "",
                passReturnedDateTime: "0001-01-01T00:00:00",
                passNo: "string",
                groupAppointmentId: AppId,
                checkinType: checkType,
                status: "",
                checkOutType: null,
                temperature: 0,
                txtManagersID: "",
                txtFloor: "",
                txtMeetingRoom: "",
                isCoupon: 0,
                assitanceRequired: addformData.assistanceRequired,
                serviceProviderAccess: addformData.serviceProviderAccess,
                wifiRequired: addformData.wifiRequired,
                escort: addformData.escortRequired,
                additionalNotification: addformData.additionalNotification,
                CardNumber: addformData.CardNumber,
                notifyTo: addformData.notifyTo,
                messageToVisitor: addformData.additionalMessage,
                checkinInstruction: addformData.checkInInstructions,
                allDay: addformData.isAllDay,
                repeatVisit: addformData.repeatVisit,
                recurrancePattern: addformData.recurrencePattern,
                recurEvery: parseInt(addformData.recurEvery, 10),
                selectedRecurrence: addformData.selectedRecurrence,
                country: "",
                hostName: empID,
                firstName: formData.firstName,
                middleName: formData.middleName,
                lastName: formData.lastName,
                nationality: formData.nationality,
                gender: formData.gender,
                nationalityCode: leaderCode,
                uploadDocument: addformData.uploadDocument,
                NdaDocument: addformData.NdaDocument,
                GroupMemberId: null,
              },
            ]
          : []),
        ...selectedRowData.map((row) => ({
          groupLeaderName: row.firstName,
          visitorMobile: String(row.visitorMobile),
          CardNumber: row.cardNumber,
          visitorAssets: row.asset,
          groupMemberEmail: row.groupMemberEmail,
          visitorCompany: row.gender,
          // visitorEmail: formData.visitorEmail,
          vehicleno: formData.vehicleno,
          appointmentStatus: "Scheduled",
          createdBy: Number(empID),
          // createdDate: formatDateForApi(formData.meetingFrom),
          modifiedBy: Number(empID),
          modifiedDate: checkInDateTime,
          checkInDateTime: checkInDateTime,
          // appointmentDate: formatDateForApi(formData.meetingFrom), // Assuming this needs to be current date
          meetingVenue: formData.meetingVenue,
          // idProofType: row['ID Proof(eg:Passport)'] || '',
          idProofId: row?.idProofType || 0,
          visitorIdNumber: String(row.idProofNo),
          validTill: formData.meetingTo, // Assuming 1 hour from now
          selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
          checkinType: checkType,
          txtManagersID: "null",
          visitorPhoto:
            typeof row.photo === "string" && row.photo.startsWith("data:image")
              ? getPhotoFromProfileImage(row.photo)
              : row.photo,
          txtFloor: "null",
          txtMeetingRoom: "null",
          txtCostCenter: "null",
          gate: getGateID.data.id,
          building: getBuildingID.data.id,
          remarks: formData.remarks,
          purpose: formData.purpose,
          country: "",
          groupAppointmentId: AppId,
          locationId: getLocation.data.id,
          hostName: empID,
          firstName: row.firstName,
          middleName: row.middleName,
          lastName: row.lastName,
          nationality: row.nationality,
          gender: row.gender,
          nationalityCode: row.nationalityCode,
          GroupMemberId: getGroupMemberId(row.id),
        })),
      ];
      console.log("formData.visitorPhoto", formData.visitorPhoto);
      // setProfileImage(`data:image/png;base64,${formData.visitorPhoto}`);

      console.log("Request Data:", requestData);
      try {
        const response = await axios.post("/GroupCheckIn", requestData);
        console.log("response", response);
        const checkInId = response?.data[0]?.checkInId;
        const memberCheckInIds = response?.data?.slice(GroupType ? 1 : 0).map(item => item.checkInId); // Store member checkInIds
        console.log("memberCheckInIds_1", memberCheckInIds); // ← verify this is correct array
        const updatedFormData = {
          VisitorName: formData.firstName,
          MailSubject: "Visitor CheckIn Notification",
          MailType: "CHKINVISITOR",
          MeetingOn: formData.meetingFrom,
          VisitorMobile: formData.visitorMobile,
          MeetingVenue: formData.meetingVenue,
          txtManagersID: null,
          ManagerMail: getManagerDetails.data.managerMailID,
          SecsEmailId: null,
          VisitorCompany: formData.company,
          HostName: getManagerDetails.data.employeeName,
          ToAddress: formData.visitorEmail,
        };
        console.log("updatedFormData", updatedFormData);
        const updateMail = await axios.post("/Mail", updatedFormData);
        console.log("updateMail", updateMail);
        // const sendSmsData = {
        //   AppointmentDtTm: formData.meetingFrom,
        //   AppointmentVenue: formData.meetingVenue || '',
        //   ContactNo: "+91" + getManagerDetails.data.employeeMobile,
        //   HostName: getManagerDetails.data.employeeName,
        //   SMSType: "MsgToHostCHKIN",
        //   VisitorName: formData.visitorName,
        //   txtManagersID: null
        // }
        // console.log("sendSmsData", sendSmsData);
        // const updateSendSms = await axios.post('/SendSMS', sendSmsData);
        // console.log("updateSendSms", updateSendSms);

        if (response.status === 200) {
          // if (isCheckedB) {
          //   const encodedId = encodeCheckInId(checkInId);
          //   setGetCheck(encodedId)
          //   console.log(encodedId);
          //   // const decodedId = decodeCheckInId(encodedId);

          //   const formattedData = `${encodedId}`;
          //   setQrCodeValueV(formattedData);
          //   console.log("Formatted QR Code Data", formattedData);
          //   setShowQRCode(true);
          //   const formattedDataN = `${encodedId}`;
          //   setQrCodeValueV(formattedDataN);
          // }
          // else {
          const generateQRCode = () => {
            const encodedId = encodeCheckInId(checkInId);
            console.log(encodedId);
            // const decodedId = decodeCheckInId(encodedId);
            setGetCheck(encodedId);
            const formattedData = `${encodedId}`;
            setQrCodeValueV(formattedData);
            console.log("Formatted QR Code Data", formattedData);
          };
          console.log("formData.visitorPhoto", formData.visitorPhoto);
          setProfileImage(`data:image/png;base64,${formData.visitorPhoto}`);
          generateQRCode();
          const generateQRCodeN = () => {
            const encodedId = encodeCheckInId(checkInId);
            setGetCheck(encodedId);
            console.log(encodedId);
            // const decodedId = decodeCheckInId(encodedId);
            const formattedData = `${encodedId}`;
            setQrCodeValueV(formattedData);
            generateQRCodeN();
          };
          // printQRCodeV();
          printQRCodeV(checkInId, memberCheckInIds);
        }

        // Handle the response data, e.g., display details or update state
        //}
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    } else {
      const selectedRowData = selectedRows.map(
        (rowIndex) => tableData[rowIndex],
      ); // Get actual row data

      const requestData = [
        ...(GroupType
          ? [
              {
                checkInId: 0,
                hostName: String(getManagerDetails.data.id),
                hostMobile: getManagerDetails.data.employeeMobile,
                hostEmail: getManagerDetails.data.employeeMailId,
                checkInDateTime: checkInDateTime,
                visitorName: formData.firstName,
                visitorMobile: formData.visitorMobile,
                visitorCompany: formData.company,
                vehicleno: formData.vehicleno,
                selectedVisitorTypeId: formData.selectedVisitorTypeId,
                locationId: getLocation.data.id,
                departmentId: 0,
                remarks: formData.remarks,
                idProofId: parseInt(formData.selectedIdProofTypeId) || 0,
                visitorIdNumber: formData?.idProofNo,
                visitorAssets: formData.assets,
                purpose: formData.purpose,
                visitorPhoto: formData.visitorPhoto,
                gate: getGateID.data.id,
                building: getBuildingID.data.id,
                visitorSignature: "",
                duration: "",
                passReturned: "",
                passReturnedDateTime: "0001-01-01T00:00:00",
                passNo: "string",
                groupAppointmentId: AppId,
                checkinType: checkType,
                status: "",
                checkOutType: null,
                temperature: 0,
                txtManagersID: "",
                txtFloor: "",
                txtMeetingRoom: "",
                isCoupon: 0,
                country: "",
                CardNumber: addformData.CardNumber,
                assitanceRequired: addformData.assistanceRequired,
                serviceProviderAccess: addformData.serviceProviderAccess,
                wifiRequired: addformData.wifiRequired,
                escort: addformData.escortRequired,
                additionalNotification: addformData.additionalNotification,
                notifyTo: addformData.notifyTo,
                messageToVisitor: addformData.additionalMessage,
                checkinInstruction: addformData.checkInInstructions,
                hostName: empID,
                firstName: formData.firstName,
                middleName: formData.middleName,
                lastName: formData.lastName,
                nationality: formData.nationality,
                gender: formData.gender,
                nationalityCode: leaderCode,
                uploadDocument: addformData.uploadDocument,
                NdaDocument: addformData.NdaDocument,
                GroupMemberId: null,
              },
            ]
          : []),
        ...selectedRowData.map((row) => ({
          groupLeaderName: row.firstName,
          CardNumber: row.cardNumber,
          visitorAssets: row.asset,
          visitorMobile: String(row.visitorMobile),
          groupMemberEmail: row.groupMemberEmail,
          visitorCompany: row.company,
          // visitorEmail: formData.visitorEmail, // Assuming this comes from somewhere else or left empty
          appointmentStatus: "Scheduled",
          vehicleno: formData.vehicleno,
          createdBy: Number(empID),
          remarks: formData.remarks,
          // createdDate: formatDateForApi(formData.meetingFrom),
          modifiedBy: Number(empID),
          modifiedDate: checkInDateTime,
          checkInDateTime: checkInDateTime,
          // appointmentDate: formatDateForApi(formData.meetingFrom), // Assuming this needs to be current date
          meetingVenue: formData.meetingVenue,
          // idProofType: row['ID Proof(eg:Passport)'] || '',
          idProofId: row?.idProofType || 0,
          visitorIdNumber: String(row.idProofNo),
          validTill: formData.meetingTo, // Assuming 1 hour from now
          selectedVisitorTypeId: Number(formData.selectedVisitorTypeId),
          txtManagersID: "null",
          visitorPhoto:
            typeof row.photo === "string" && row.photo.startsWith("data:image")
              ? getPhotoFromProfileImage(row.photo)
              : row.photo,
          txtFloor: "null",
          txtMeetingRoom: "null",
          txtCostCenter: "null",
          checkinType: checkType,
          gate: getGateID.data.id,
          building: getBuildingID.data.id,
          purpose: formData.purpose,
          country: "",
          groupAppointmentId: AppId,
          locationId: getLocation.data.id,
          hostName: empID,
          firstName: row.firstName,
          middleName: row.middleName,
          lastName: row.lastName,
          nationality: row.nationality,
          gender: row.gender,
          nationalityCode: row.nationalityCode,
          GroupMemberId: getGroupMemberId(row.id),
        })),
      ];
      console.log("formData.visitorPhoto", formData.visitorPhoto);

      setProfileImage(`data:image/png;base64,${formData.visitorPhoto}`);

      console.log("Request Data:", requestData);
      try {
        const response = await axios.post("/GroupCheckIn", requestData);
        console.log("response", response);
        const checkInId = response?.data[0]?.checkInId;
        const memberCheckInIds = response?.data?.slice(GroupType ? 1 : 0).map(item => item.checkInId); // Store member checkInIds
        console.log("memberCheckInIds_2", memberCheckInIds); // ← verify this is correct array
        const updatedFormData = {
          VisitorName: formData.firstName,
          MailSubject: "Visitor CheckIn Notification",
          MailType: "CHKINVISITOR",
          MeetingOn: formData.meetingFrom,
          VisitorMobile: formData.visitorMobile,
          MeetingVenue: formData.meetingVenue,
          txtManagersID: null,
          ManagerMail: getManagerDetails.data.managerMailID,
          SecsEmailId: null,
          VisitorCompany: formData.company,
          HostName: getManagerDetails.data.employeeName,
          ToAddress: formData.visitorEmail,
        };
        console.log("updatedFormData", updatedFormData);
        const updateMail = await axios.post("/Mail", updatedFormData);
        console.log("updateMail", updateMail);
        const sendSmsData = {
          AppointmentDtTm: formData.meetingFrom,
          AppointmentVenue: formData.meetingVenue || "",
          ContactNo: "+91" + getManagerDetails.data.employeeMobile,
          HostName: getManagerDetails.data.employeeName,
          SMSType: "MsgToHostCHKIN",
          VisitorName: formData.visitorName,
          txtManagersID: null,
        };
        // console.log("sendSmsData", sendSmsData);
        // const updateSendSms = await axios.post('/SendSMS', sendSmsData);
        // console.log("updateSendSms", updateSendSms);

        if (response.status === 200) {
          // if (isCheckedB) {
          //   const encodedId = encodeCheckInId(checkInId);
          //   console.log(encodedId);
          //   setGetCheck(encodedId)
          //   // const decodedId = decodeCheckInId(encodedId);
          //   // console.log("decodedId",decodedId);
          //   const formattedData = `${encodedId}`;
          //   setQrCodeValueV(formattedData);
          //   console.log("Formatted QR Code Data", formattedData);
          //   setShowQRCode(true);
          //   const formattedDataN = `${encodedId}`;
          //   setQrCodeValueV(formattedDataN);
          //   setGetCheck(encodedId)
          // }
          // else {
          const generateQRCode = () => {
            const encodedId = encodeCheckInId(checkInId);
            console.log(encodedId);
            setGetCheck(encodedId);
            // const decodedId = decodeCheckInId(encodedId);
            // console.log("decodedId",decodedId);
            const formattedData = `${encodedId}`;
            setQrCodeValueV(formattedData);
            console.log("Formatted QR Code Data", formattedData);
          };
          console.log("formData.visitorPhoto", formData.visitorPhoto);
          setProfileImage(`data:image/png;base64,${formData.visitorPhoto}`);
          generateQRCode();
          const generateQRCodeN = () => {
            const encodedId = encodeCheckInId(checkInId);
            console.log(encodedId);
            setGetCheck(encodedId);
            // const decodedId = decodeCheckInId(encodedId);
            // console.log("decodedId",decodedId);

            const formattedData = `${encodedId}`;
            setQrCodeValueV(formattedData);
            generateQRCodeN();
          };
          // printQRCodeV();
          printQRCodeV(checkInId, memberCheckInIds);

        }

        // Handle the response data, e.g., display details or update state
        //  }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };
  const [showQRCode, setShowQRCode] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState("");
  function encodeCheckInId(checkInId) {
    // Mapping digits to specific encoded pairs
    const digitMapping = {
      1: "515253",
      3: "303030",
      5: "505050",
      2: "202020",
      4: "868484",
      6: "606060",
      7: "707070",
      8: "808080",
      9: "909090",
      0: "000000",
    };

    // Convert the Check-In ID to a string and map each digit to its corresponding encoding
    const checkInIdStr = checkInId.toString();
    const encoded = checkInIdStr
      .split("") // Split into individual digits
      .map((digit) => digitMapping[parseInt(digit)]) // Map digits to encoded values
      .join(""); // Join all the parts to form the final encoded string

    return encoded;
  }
  function decodeCheckInId(qrcode) {
    // Mapping encoded byte pairs back to digits
    const reverseMapping = {
      515253: "1",
      303030: "3",
      505050: "5",
      202020: "2",
      868484: "4",
      606060: "6",
      707070: "7",
      808080: "8",
      909090: "9",
      "000000": "0",
    };

    let checkInId = "";

    // Loop through the qrcode string in steps of 6 characters (each code is 6 characters long)
    for (let i = 0; i < qrcode.length; i += 6) {
      const segment = qrcode.substring(i, i + 6); // Extract each 6-character segment
      // Check if the segment exists in the reverse mapping
      if (reverseMapping[segment]) {
        checkInId += reverseMapping[segment]; // Map the segment back to the corresponding digit
      } else {
        console.error(`Error: Segment ${segment} not found in reverse mapping`);
        return ""; // Return an empty string if an invalid segment is encountered
      }
    }

    return checkInId; // Return the decoded check-in ID
  }
  function encryptMobileNumber(mobile) {
    let encryptedNumber = "";

    // Iterate over each digit of the mobile number
    for (let i = 0; i < mobile.length; i++) {
      // Convert the digit to its ASCII code and pad it to two digits
      const asciiCode = mobile[i].charCodeAt(0).toString().padStart(2, "0");
      encryptedNumber += asciiCode; // Concatenate to the encrypted string
    }

    return encryptedNumber;
  }
  const qrCodeRef = useRef(); // Create a ref to access the QR code canvas
  const printer = async () => {
    printQRCode();
    printQRCodeV();
  };

  const printQRCode = async () => {
    // Create a new iframe element
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    // Convert QR code to data URL
    const qrCodeDataUrlV = qrCodeRefV.current.toDataURL();

    // Fetch the SVG image and convert to base64
    const response = await fetch(centerImage);
    const blob = await response.blob();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64Svg = reader.result;

      // Write the content into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();

      doc.write(`
            <html>
              <head>
                <title>Print QR Code</title>
                <style>
                  /* Reset default print margins */
                  @page { margin: 0; }
                  body {
                    font-family: Arial, sans-serif;
                    margin: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }
                  h2 {
                    font-size: 1.5em;
                    margin: 10px 0;
                  }
                  .visitor-label, .baggage-label {
                    display: inline-block;
                    background-color: #FF7A00;
                    padding: 5px;
                    width:300px;
                    color: #FFF;
                    font-weight: bold;
                    font-size: 1.2em;
                    margin: 10px 0;
                    text-align: center;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }
                  p {
                    font-size: 0.8em;
                    color: #888;
                  }
                  img {
                    max-width: 100%;
                    margin: 10px 0;
                  }
                </style>
              </head>
              <body>
                <!-- SVG Image Above Header -->
                <div style="text-align: center; margin-bottom: 10px;">
                  <img src="${base64Svg}" alt="Infosys Logo" style="width: 170px; height: 100px;" />
                </div>
      
                <h2>${[formData.firstName, formData.middleName, formData.lastName].filter(Boolean).join(" ")}</h2>
                <div class="visitor-label">VISITOR</div>
                <img src="${qrCodeDataUrlV}" alt="QR Code" />
                <div class="baggage-label">BAGGAGE TAG</div>
                <p>Visitor Management System</p>
              </body>
            </html>
          `);
      doc.close();

      // Use onload event to ensure the content and styles are fully loaded before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe); // Remove the iframe after printing
        }, 500);
        // Slight delay for style rendering
      };
    };
  };
  const closeQRCodePopup = () => {
    printQRCodeV();
    setShowQRCode(false);
  };

  const [showQRCodeV, setShowQRCodeV] = useState(false);
  const [qrCodeValueV, setQrCodeValueV] = useState("");
  const closeQRCodePopupV = () => {
    // setShowQRCodeV(false);
    printQRCodeV();
    navigate("/layout/Dashboard/Dashboard");
  };
  const qrCodeRefV = useRef(); // Create a ref to access the QR code canvas

  const [baggageTag, setBaggageTag] = useState("");
  const [showBaggageTag, setShowBaggageTag] = useState(false);
  const [detailsVisitor, setDetailsVisitor] = useState({});

  useEffect(() => {
    // Expose global function for HTML buttons
    window.baggageTagClose = () => {
      setShowBaggageTag(false); // hide popup if needed
      handleReprintPassBoth(detailsVisitor, window._memberCheckInIds || []);
    };

    window.baggageTagPrint = () => {
      if (!baggageTag) {
        console.warn("No baggage tag data to print");
        return;
      }

      // ✅ Create a hidden iframe for printing
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      // ✅ Set the onload handler BEFORE writing document
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        }, 500);
      };

      // ✅ Write baggageTag HTML into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
          <html>
            <head>
              <title>Baggage Tag</title>
              <style>
                  @page { size: auto; margin: 0; }
                  @media print {
                    body { margin: 0 !important; padding: 0 !important; }
                    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                  }
              </style>
            </head>
            <body>
              ${baggageTag}
            </body>
          </html>
          `);

      doc.close();
    };
  }, [detailsVisitor, baggageTag]);

  // const printQRCodeV = async () => {
  //   if (!GroupType) {
  //     handlePrintAllMembers();
  //     return;
  //   }
  const printQRCodeV = async (leaderCheckInId, memberCheckInIds) => {
  if (!GroupType) {
    handlePrintAllMembers(memberCheckInIds);
    return;
  }
    // Create a new iframe element
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
    console.log("getCheck", getCheck);
    const formattedMobileNumber = `${leaderCode}-${formData.visitorMobile}`;

    // const responseWVV = await axios.get(
    //   `/GroupCheckIn/GroupCheckIn/${formattedMobileNumber}`,
    // );
    // setGetCheck(responseWVV.data.checkInId);
    // const encodedId = encodeCheckInId(responseWVV.data.checkInId);
    // const formattedData = `${encodedId}`;
    // // const decodedId = decodeCheckInId(getCheck);

    // const responseWV = await axios.get(`/GroupCheckIn/${responseWVV.data.checkInId}`);
    // Replace the responseWVV axios.get block with direct usage:
    const responseWV = await axios.get(`/GroupCheckIn/${leaderCheckInId}`);


    const details = responseWV?.data;

    // Ensure details is always an array
    const detailsArray = Array.isArray(details) ? details : [details];

    for (const detail of detailsArray) {
      if (!detail.badgeFront && !detail.badgeBack) {
        toast.warning("No visitor pass available.");
        setTimeout(() => navigate("/layout/Dashboard/Dashboard"), 1500); // wait 1.5s
        return;
      }

      //  If baggageTag exists → show it first, store iframe for later
      if (detail.baggageTag && isCheckedB) {
        console.log(detail.baggageTag);
        setBaggageTag(detail.baggageTag);
        setDetailsVisitor(detail);
        setShowBaggageTag(true);
        // Store memberCheckInIds for later use in baggageTagClose
      window._memberCheckInIds = memberCheckInIds; // ← store globally for baggage flow
      } else {
        handleReprintPassBoth(detail, memberCheckInIds);
      }
    }
  };

  const handleReprintPassBoth = async (detail, memberCheckInIds) => {
    console.log("handleReprintPassBoth>>>>>", memberCheckInIds);
    try {
      // Create hidden iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Visitor Pass</title>
            <style>
              @page { margin: 0; }
              body { 
                margin: 0; 
                display: flex; 
                justify-content: space-around;
                align-items: flex-start;
                padding: 5px;
              }
              .badge {
                margin: 10px;
                width: 8cm;      /* fixed width */
                height: 49cm;    /* tall enough for content */
                box-sizing: border-box;
              }
              @media print {
                .no-print { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="badge">
              ${detail.badgeFront || ""}
            </div>
            <div class="badge">
              ${detail.badgeBack || ""}
            </div>
          </body>
        </html>
      `);
      doc.close();
      // Use onload event to ensure the content and styles are fully loaded before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe); // Remove the iframe after printing
        }, 500);
        if (GroupType) {
          navigate("/layout/Dashboard/Dashboard");
        }
        handlePrintAllMembers(memberCheckInIds);
        // navigate('/layout/Dashboard/Dashboard');
        // Slight delay for style rendering
      };
    } catch (error) {
      console.error("Error in printQRCodeV:", error);
    }
  };

  const generateQRCodeForMember = async (memberData) => {
    const formattedData = `${encryptMobileNumber(formData.visitorMobile)}`;
    setQrCodeValueV(formattedData);
    console.log("Generating QR code for:", memberData);

    // Wait for the QR code data to be generated (you may need to refactor this depending on the actual data handling)
    await new Promise((resolve) => setTimeout(resolve, 100)); // A small delay to ensure QR code is ready
  };

  const handlePrintAllMembers = async (memberCheckInIds) => {
    const generateQRCode = () => {
      const formattedData = `${encryptMobileNumber(formData.visitorMobile)}`;

      setQrCodeValueV(formattedData);
      console.log("Formatted QR Code Data", formattedData);
    };
    generateQRCode();
    // const selectedRowData = selectedRows.map((rowIndex) => tableData[rowIndex]); // Get actual row data
    const selectedRowData = selectedRows.map((rowIndex) => tableData[rowIndex]);
    console.log("Members areeee>>>>", selectedRowData);
    console.log("memberCheckInIds in handlePrintAllMembers>>", memberCheckInIds); // ← verify

    // for (const member of selectedRowData) {
    //   await generateQRCodeForMember(member);
    //   await printQRCodeG(member); // Print QR code for each member
    // }
    for (let i = 0; i < selectedRowData.length; i++) {
    await generateQRCodeForMember(selectedRowData[i]);
    await printQRCodeG(selectedRowData[i], memberCheckInIds[i]); // Pass checkInId directly
  }
  };

  const printQRCodeG = async (memberData, memberCheckInId) => {
    console.log("memberData", memberData);

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
    //     const formattedData = `
    //     ${encryptMobileNumber(memberData.visitorMobile)}

    // `;
    console.log("getCheck", getCheck);

    // const decodedId = decodeCheckInId(getCheck);
    const formattedMobileNumber = `${memberData.nationalityCode}-${memberData.visitorMobile}`;

    // const responseWVV = await axios.get(
    //   `/GroupCheckIn/GroupCheckIn/${formattedMobileNumber}`,
    // );
    // setGetCheck(responseWVV.data.checkInId);
    // const encodedId = encodeCheckInId(responseWVV.data.checkInId);
    // const formattedData = `${encodedId}`;

    // const responseWV = await axios.get(`/GroupCheckIn/${responseWVV.data.checkInId}`);
    // Replace the responseWVV axios.get block with direct usage:
  const responseWV = await axios.get(`/GroupCheckIn/${memberCheckInId}`);
    const details = responseWV?.data;

    // Ensure details is always an array
    const detailsArray = Array.isArray(details) ? details : [details];

    for (const detail of detailsArray) {
      if (!detail.badgeFront && !detail.badgeBack) {
        toast.warning("No visitor pass available.");
        setTimeout(() => navigate("/layout/Dashboard/Dashboard"), 1500); // wait 1.5s
        return;
      }

      // Create hidden iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Visitor Pass</title>
            <style>
              @page { margin: 0; }
              body { 
                margin: 0; 
                display: flex; 
                justify-content: space-around;
                align-items: flex-start;
                padding: 5px;
              }
              .badge {
                margin: 10px;
                width: 8cm;      /* fixed width */
                height: 49cm;    /* tall enough for content */
                box-sizing: border-box;
              }
              @media print {
                .no-print { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="badge">
              ${detail.badgeFront || ""}
            </div>
            <div class="badge">
              ${detail.badgeBack || ""}
            </div>
          </body>
        </html>
      `);
      doc.close();

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        }, 500);
        navigate("/layout/Dashboard/Dashboard");
      };
    }
  };

  const generateQRCodeDataUrl = (data) => {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(data, { width: 256, margin: 1 }, (err, url) => {
        if (err) {
          console.error("Error generating QR Code:", err);
          reject(err);
        } else {
          resolve(url); // Return the data URL
        }
      });
    });
  };

  const [cameraStates, setCameraStates] = useState(
    Array(tableData.length).fill(false),
  );
  const [buttonLabels, setButtonLabels] = useState(
    Array(tableData.length).fill("Take photo"),
  );
  const webcamRef = useRef(null);

  useEffect(() => {
    setButtonLabels(Array(cameraStates.length).fill("Take photo"));
  }, [cameraStates.length]);

  const handleCapture = async (index) => {
    const updatedCameraStates = [...cameraStates];
    const updatedButtonLabels = [...buttonLabels];

    // Toggle camera state for the specific row
    if (!updatedCameraStates[index]) {
      // If the camera is off, turn it on
      updatedCameraStates[index] = true;
      updatedButtonLabels[index] = "Capture";
    } else {
      // If the camera is on, capture the image
      const imageSrc = webcamRef.current.getScreenshot();

      if (imageSrc) {
        // Create an image element from the captured screenshot
        const img = new Image();
        img.src = imageSrc;

        img.onload = async () => {
          // Create a canvas for image processing
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");

          // Draw the captured image onto the canvas
          ctx.drawImage(img, 0, 0, img.width, img.height);
          const faceDetection = new FaceDetection({
            locateFile: (file) =>
              `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
          });

          faceDetection.setOptions({
            model: "short", // fast + accurate model
            minDetectionConfidence: 0.5,
          });

          await faceDetection.initialize();

          // Run face detection
          const detectionResults = await new Promise((resolve) => {
            faceDetection.onResults(resolve);
            faceDetection.send({ image: img });
          });

          // Check if face is detected
          if (
            !detectionResults.detections ||
            detectionResults.detections.length === 0
          ) {
            toast.error("Human face not detected");
            return;
          }

          // Initialize MediaPipe Selfie Segmentation
          const segmentation = new SelfieSegmentation({
            locateFile: (file) =>
              `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
          });

          segmentation.setOptions({
            modelSelection: 1, // General-purpose segmentation model
          });

          // Perform segmentation to remove the background
          await segmentation.initialize();
          const results = await new Promise((resolve) => {
            segmentation.onResults(resolve);
            segmentation.send({ image: img });
          });

          // Create a new canvas for output
          const outputCanvas = document.createElement("canvas");
          outputCanvas.width = img.width;
          outputCanvas.height = img.height;
          const outputCtx = outputCanvas.getContext("2d");

          // Draw the original image onto the output canvas
          outputCtx.drawImage(img, 0, 0, img.width, img.height);

          // Apply the segmentation mask to retain only the human face
          outputCtx.globalCompositeOperation = "destination-in";
          outputCtx.drawImage(
            results.segmentationMask,
            0,
            0,
            img.width,
            img.height,
          );

          // Apply a transparent background
          outputCtx.globalCompositeOperation = "destination-over";
          outputCtx.fillStyle = "transparent";
          outputCtx.fillRect(0, 0, img.width, img.height);

          // Convert the processed image to base64
          const processedBase64Image = outputCanvas.toDataURL("image/png");

          // Update the table data with the processed image
          setTableData((prevData) =>
            prevData.map((row, rowIndex) =>
              rowIndex === index
                ? { ...row, photo: processedBase64Image || row.photo }
                : row,
            ),
          );
        };
      }

      // Turn off the camera and reset button label
      updatedCameraStates[index] = false;
      updatedButtonLabels[index] = "Take photo";
    }

    // Update state with new values
    setCameraStates(updatedCameraStates);
    setButtonLabels(updatedButtonLabels);
  };

  const handleImageUpload = (e, index) => {
    const file = e.target.files[0];
    if (!file || (file.type !== "image/png" && file.type !== "image/jpeg")) {
      toast.error("Please upload a PNG or JPEG image");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const base64Image = reader.result?.split(",")[1] || ""; // Extract base64 portion
      setTableData((prevData) =>
        prevData.map((row, rowIndex) =>
          rowIndex === index
            ? { ...row, photo: base64Image || row.photo }
            : row,
        ),
      );
    };
    reader.readAsDataURL(file);
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectAll = () => {
    const selectableRows = tableData
      .map((row, index) => (!row.isCheckedIn ? index : null))
      .filter((index) => index !== null);

    if (selectedRows.length === selectableRows.length) {
      setSelectedRows([]); // Deselect all
    } else {
      setSelectedRows(selectableRows); // Select only non-disabled rows
    }
  };

  const handleRowSelect = (index, isCheckedIn) => {
    if (isCheckedIn) return; // Prevent selection if checked in

    setSelectedRows(
      (prevSelected) =>
        prevSelected.includes(index)
          ? prevSelected.filter((i) => i !== index) // Deselect
          : [...prevSelected, index], // Select
    );
    console.log("selected Row", selectedRows);
  };

  const [showEditMemberPopup, setShowEditMemberPopup] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [editMemberDetails, setEditMemberDetails] = useState({
    id: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    company: "",
    gender: "",
    nationality: "",
    mobileNumber: "",
    idProofName: "",
    idNumber: "",
    cardNumber: "",
    asset: "",
  });

  const handleEditClick = (index) => {
    const selectedRow = tableData[index];
    setEditIndex(index);
    setEditMemberDetails({
      id: selectedRow.id,
      firstName: selectedRow.firstName || "",
      middleName: selectedRow.middleName || "",
      lastName: selectedRow.lastName || "",
      email: selectedRow.groupMemberEmail || "",
      company: selectedRow.company || "",
      gender: selectedRow.gender || "",
      nationality: selectedRow.nationality || "",
      mobileNumber: selectedRow.visitorMobile || "",
      idProofName: selectedRow.idProofName || "",
      idNumber: selectedRow.idProofNo || "",
      cardNumber: selectedRow.cardNumber || "",
      asset: selectedRow.asset || "",
    });
    setShowEditMemberPopup(true);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditMemberDetails((prev) => ({ ...prev, [name]: value }));
  };
  const handleUpdateMember = () => {
    const updatedTable = [...tableData];
    updatedTable[editIndex] = {
      ...updatedTable[editIndex],
      cardNumber: editMemberDetails.cardNumber,
      asset: editMemberDetails.asset,
    };
    setTableData(updatedTable);
    console.log("tableData", tableData);

    setShowEditMemberPopup(false);
  };

  return (
    <Container>
      <ToastContainer />
      <Header>
        <Heading>Group Member Details</Heading>
      </Header>
      <ButtonsContainer>
        {/* <ButtonGroupLeft>
          <Button onClick={handleChooseFileClick}>Choose File</Button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
          <Button onClick={handleUploadFileClick} disabled={!file}>
            Upload File
          </Button>
        </ButtonGroupLeft> */}
        <ButtonGroupRight>
          {/* <Button onClick={handleSampleTemplateClick}>Sample Template</Button> */}
          <Button onClick={handleSubmitClick}>Submit</Button>
        </ButtonGroupRight>
      </ButtonsContainer>
      <ScrollableTableContainer>
        <TableContainer>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={
                        selectedRows.length ===
                          tableData.filter((row) => !row.isCheckedIn).length &&
                        tableData.length > 0
                      }
                    />
                    Select To Include
                  </label>
                </TableHeaderCell>
                <TableHeaderCell>First Name</TableHeaderCell>
                <TableHeaderCell>Middle Name</TableHeaderCell>
                <TableHeaderCell>Last Name</TableHeaderCell>
                <TableHeaderCell>Email</TableHeaderCell>
                <TableHeaderCell>Company</TableHeaderCell>
                <TableHeaderCell>gender</TableHeaderCell>
                <TableHeaderCell>Nationality</TableHeaderCell>
                <TableHeaderCell>ISD</TableHeaderCell>
                <TableHeaderCell>Mobile Number</TableHeaderCell>
                <TableHeaderCell>ID Proof Type</TableHeaderCell>
                <TableHeaderCell>ID Proof No</TableHeaderCell>
                <TableHeaderCell>Group Member Photo</TableHeaderCell>
                <TableHeaderCell>Action</TableHeaderCell>{" "}
                {/* Add Action Column */}
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => {
                  const isDisabled = row.isCheckedIn;
                  return (
                    <React.Fragment key={index}>
                      {isDisabled ? (
                        <DisabledRow>
                          <TableCell style={{ textAlign: "center" }}>
                            <input type="checkbox" disabled />
                          </TableCell>
                          <TableCell>{row.firstName}</TableCell>
                          <TableCell>{row.middleName}</TableCell>
                          <TableCell>{row.lastName}</TableCell>
                          <TableCell>{row.groupMemberEmail}</TableCell>
                          <TableCell>{row.company}</TableCell>
                          <TableCell>{row.gender}</TableCell>
                          <TableCell>{row.nationality}</TableCell>
                          <TableCell>{row.nationalityCode}</TableCell>
                          <TableCell>{row.visitorMobile}</TableCell>
                          <TableCell>{row.idProofName}</TableCell>
                          <TableCell>{row.idProofNo}</TableCell>

                          <TableCell>
                            <Circle>
                              <WebcamContainer>
                                {cameraStates[index] ? (
                                  <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/png"
                                    width="100%"
                                    height="100%"
                                    videoConstraints={{
                                      width: 200,
                                      height: 200,
                                      facingMode: "user",
                                    }}
                                  />
                                ) : row.photo ? (
                                  <img
                                    src={
                                      row.photo.startsWith(
                                        "data:image/png;base64,",
                                      )
                                        ? row.photo
                                        : `data:image/png;base64,${row.photo}`
                                    }
                                    alt="Profile"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: "50%",
                                    }}
                                  />
                                ) : (
                                  <ProfileIcon>
                                    <User size={20} />
                                  </ProfileIcon>
                                )}
                              </WebcamContainer>
                            </Circle>
                            <ButtonRow>
                              <PhotoButton onClick={() => handleCapture(index)}>
                                Take Photo
                              </PhotoButton>
                              <ActionButton>
                                <label
                                  htmlFor={`upload-button-${index}`}
                                  style={{ cursor: "pointer", fontSize: "9px" }}
                                >
                                  Upload images
                                </label>
                                <input
                                  type="file"
                                  id={`upload-button-${index}`}
                                  accept="image/png, image/jpeg"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleImageUpload(e, index)}
                                />
                              </ActionButton>
                            </ButtonRow>
                          </TableCell>
                          <TableCell>
                            <IconWrapper onClick={() => handleEditClick(index)}>
                              <FiEdit />
                            </IconWrapper>
                          </TableCell>
                        </DisabledRow>
                      ) : (
                        <TableRow>
                          <TableCell style={{ textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() =>
                                handleRowSelect(index, row.isCheckedIn)
                              }
                            />
                          </TableCell>
                          <TableCell>{row.firstName}</TableCell>
                          <TableCell>{row.middleName}</TableCell>
                          <TableCell>{row.lastName}</TableCell>
                          <TableCell>{row.groupMemberEmail}</TableCell>
                          <TableCell>{row.company}</TableCell>
                          <TableCell>{row.gender}</TableCell>
                          <TableCell>{row.nationality}</TableCell>
                          <TableCell>{row.nationalityCode}</TableCell>
                          <TableCell>{row.visitorMobile}</TableCell>
                          <TableCell>{row.idProofName}</TableCell>
                          <TableCell>{row.idProofNo}</TableCell>

                          <TableCell>
                            <Circle>
                              <WebcamContainer>
                                {cameraStates[index] ? (
                                  <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/png"
                                    width="100%"
                                    height="100%"
                                    videoConstraints={{
                                      width: 200,
                                      height: 200,
                                      facingMode: "user",
                                    }}
                                  />
                                ) : row.photo ? (
                                  <img
                                    src={
                                      row.photo.startsWith(
                                        "data:image/png;base64,",
                                      )
                                        ? row.photo
                                        : `data:image/png;base64,${row.photo}`
                                    }
                                    alt="Profile"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: "50%",
                                    }}
                                  />
                                ) : (
                                  <ProfileIcon>
                                    <User size={20} />
                                  </ProfileIcon>
                                )}
                              </WebcamContainer>
                            </Circle>
                            <ButtonRow>
                              <PhotoButton onClick={() => handleCapture(index)}>
                                Take Photo
                              </PhotoButton>
                              <ActionButton>
                                <label
                                  htmlFor={`upload-button-${index}`}
                                  style={{ cursor: "pointer", fontSize: "9px" }}
                                >
                                  Upload images
                                </label>
                                <input
                                  type="file"
                                  id={`upload-button-${index}`}
                                  style={{ display: "none" }}
                                  onChange={(e) => handleImageUpload(e, index)}
                                />
                              </ActionButton>
                            </ButtonRow>
                          </TableCell>
                          <TableCell>
                            <IconWrapper onClick={() => handleEditClick(index)}>
                              <FiEdit />
                            </IconWrapper>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan="12">No data available</TableCell>
                </TableRow>
              )}
              {showEditMemberPopup && (
                <Popup>
                  <PopupText>Update Member</PopupText>

                  {[
                    { label: "First Name", key: "firstName" },
                    { label: "Middle Name", key: "middleName" },
                    { label: "Last Name", key: "lastName" },
                    { label: "Email", key: "email" },
                    { label: "Company", key: "company" },
                  ].map(({ label, key }) => (
                    <LabelValueContainer key={key}>
                      <Label>
                        {label}:<Asterisk>*</Asterisk>
                      </Label>
                      <Value>
                        <Input
                          name={key}
                          type="text"
                          value={editMemberDetails[key]}
                          onChange={handleInputChange}
                          placeholder={`Enter ${label}`}
                          disabled
                        />
                      </Value>
                    </LabelValueContainer>
                  ))}

                  <LabelValueContainer>
                    <Label>
                      Gender:<Asterisk>*</Asterisk>
                    </Label>
                    <Value>
                      <Dropdown
                        name="gender"
                        value={editMemberDetails.gender}
                        onChange={handleInputChange}
                        disabled
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </Dropdown>
                    </Value>
                  </LabelValueContainer>

                  <LabelValueContainer>
                    <Label>
                      Nationality:<Asterisk>*</Asterisk>
                    </Label>
                    <Value>
                      <Input
                        name="idNumber"
                        type="text"
                        value={editMemberDetails.nationality}
                        onChange={handleInputChange}
                        disabled
                      />
                    </Value>
                  </LabelValueContainer>

                  <LabelValueContainer>
                    <Label>
                      Mobile Number:<Asterisk>*</Asterisk>
                    </Label>
                    <Value>
                      <Input
                        name="mobileNumber"
                        type="text"
                        value={editMemberDetails.mobileNumber}
                        onChange={handleInputChange}
                        disabled
                      />
                    </Value>
                  </LabelValueContainer>

                  <LabelValueContainer>
                    <Label>
                      ID Proof:<Asterisk>*</Asterisk>
                    </Label>
                    <Value>
                      <Input
                        name="idNumber"
                        type="text"
                        value={editMemberDetails.idProofName}
                        onChange={handleInputChange}
                        disabled
                      />
                    </Value>
                  </LabelValueContainer>

                  <LabelValueContainer>
                    <Label>
                      ID Number:<Asterisk>*</Asterisk>
                    </Label>
                    <Value>
                      <Input
                        name="idNumber"
                        maxLength={4}
                        type="text"
                        value={editMemberDetails.idNumber}
                        onChange={handleInputChange}
                        disabled
                      />
                    </Value>
                  </LabelValueContainer>

                  {/* Editable fields: Card Number & Asset */}
                  <LabelValueContainer>
                    <Label>Card Number:</Label>
                    <Value>
                      <Input
                        name="cardNumber"
                        type="text"
                        value={editMemberDetails.cardNumber}
                        onChange={handleInputChange}
                        placeholder="Enter Card Number"
                      />
                    </Value>
                  </LabelValueContainer>

                  <LabelValueContainer>
                    <Label>Asset:</Label>
                    <Value>
                      <Input
                        name="asset"
                        type="text"
                        value={editMemberDetails.asset}
                        onChange={handleInputChange}
                        placeholder="Enter Asset"
                      />
                    </Value>
                  </LabelValueContainer>

                  <ButtonContainer>
                    <PopupButton
                      onClick={() => setShowEditMemberPopup(false)}
                      style={{ backgroundColor: "red" }}
                    >
                      Cancel
                    </PopupButton>
                    <PopupButton onClick={handleUpdateMember}>
                      Update
                    </PopupButton>
                  </ButtonContainer>
                </Popup>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </ScrollableTableContainer>
      {showQRCode && (
        <PopupContainer onClick={closeQRCodePopup}>
          <PopupContent
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <img
                src={centerImage}
                alt="Infosys Logo"
                style={{ width: "170px", height: "100px" }}
              />
            </div>
            <h2 style={{ fontSize: "1.5em", margin: "10px 0" }}>
              {" "}
              {[formData.firstName, formData.middleName, formData.lastName]
                .filter(Boolean)
                .join(" ")}
            </h2>

            <div
              style={{
                backgroundColor: "#FF7A00",
                padding: "5px",
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "1.2em",
                margin: "10px 0",
              }}
            >
              VISITOR
            </div>

            {/* QR Code with Visitor Data */}
            <QRCodeCanvas ref={qrCodeRefV} value={qrCodeValueV} size={256} />
            <div
              style={{
                backgroundColor: "#FF7A00",
                padding: "5px",
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "1em",
                margin: "10px 0",
              }}
            >
              BAGGAGE TAG
            </div>

            <p style={{ fontSize: "0.8em", color: "#888" }}>
              Visitor Management System
            </p>
            <ButtonContainer>
              <PopupButton onClick={printer}>Print</PopupButton>
              <PopupButton className="no-button" onClick={closeQRCodePopup}>
                Close
              </PopupButton>
            </ButtonContainer>
          </PopupContent>
        </PopupContainer>
      )}
      {showQRCodeV && (
        <PopupContainer onClick={closeQRCodePopupV}>
          <PopupContent
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <img
                src={centerImage}
                alt="Infosys Logo"
                style={{ width: "170px", height: "100px" }}
              />
            </div>
            <h2 style={{ fontSize: "1.5em", margin: "10px 0" }}>
              {" "}
              {[formData.firstName, formData.middleName, formData.lastName]
                .filter(Boolean)
                .join(" ")}
            </h2>

            <div
              style={{
                backgroundColor: "#FF7A00",
                padding: "5px",
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "1.2em",
                margin: "10px 0",
              }}
            >
              VISITOR
            </div>

            {/* QR Code with Visitor Data */}
            <QRCodeCanvas ref={qrCodeRefV} value={qrCodeValueV} size={256} />

            {/* <div style={{ backgroundColor: '#FF7A00', padding: '5px', color: '#FFF', fontWeight: 'bold', fontSize: '1em', margin: '10px 0' }}>
                            BAGGAGE TAG
                        </div> */}

            <p style={{ fontSize: "0.8em", color: "#888" }}>
              Visitor Management System
            </p>

            <ButtonContainer>
              <PopupButton onClick={printQRCodeV}>Print</PopupButton>
              <PopupButton className="no-button" onClick={closeQRCodePopupV}>
                Close
              </PopupButton>
            </ButtonContainer>
          </PopupContent>
        </PopupContainer>
      )}
      {showBaggageTag && (
        <PopupOverlay>
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "1.5rem",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: baggageTag }} />
          </div>
        </PopupOverlay>
      )}

      {!isCheckedB && (
        <QRCodeCanvas
          ref={qrCodeRefV}
          value={qrCodeValueV}
          size={256}
          style={{ display: "none" }}
        />
      )}
      <QRCodeCanvas
        ref={qrCodeRefV}
        value={qrCodeValueV}
        size={256}
        style={{ display: "none" }} // Hide the QR code from the UI, just for data extraction
      />
    </Container>
  );
};

export default GroupMemberDetailsUploadPage;
